var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.selectedOrg, function(tag) {
        return _c(
          "el-tag",
          {
            key: tag.organizeId,
            staticStyle: { margin: "10px" },
            attrs: { closable: "" },
            on: {
              close: function($event) {
                return _vm.removeSelectedOrg(tag)
              }
            }
          },
          [_vm._v(_vm._s(tag.organizeName))]
        )
      }),
      _vm._v(" "),
      _c("el-tree", {
        staticStyle: { "margin-top": "30px" },
        attrs: { data: _vm.data, props: _vm.defaultProps },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var node = ref.node
              var data = ref.data
              return _c(
                "span",
                { staticClass: "slot-t-node" },
                [
                  _c("span", [_vm._v(_vm._s(node.label))]),
                  _vm._v(" "),
                  _c(
                    "el-popover",
                    {
                      attrs: { placement: "right", trigger: "click" },
                      model: {
                        value: data.hidden,
                        callback: function($$v) {
                          _vm.$set(data, "hidden", $$v)
                        },
                        expression: "data.hidden"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("i", {
                            staticClass: "i_close iconfont iconclose_light",
                            on: {
                              click: function($event) {
                                return _vm.close_sub_org(data)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("el-tree", {
                            staticClass: "sub_tree",
                            attrs: {
                              data: data.childOrganizes,
                              props: _vm.defaultProps
                            },
                            on: { "check-change": _vm.checkChange },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var node = ref.node
                                    var data = ref.data
                                    return _c(
                                      "span",
                                      { staticClass: "slot-t-node" },
                                      [
                                        _c("el-checkbox", {
                                          staticStyle: {
                                            "margin-right": "5px"
                                          },
                                          on: {
                                            change: function(r) {
                                              return _vm.checkChange(
                                                r,
                                                node,
                                                data
                                              )
                                            }
                                          },
                                          model: {
                                            value: data.hidden,
                                            callback: function($$v) {
                                              _vm.$set(data, "hidden", $$v)
                                            },
                                            expression: "data.hidden"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v(_vm._s(node.label))])
                                      ],
                                      1
                                    )
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "show-hidden",
                          attrs: { slot: "reference" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.printData(data)
                            }
                          },
                          slot: "reference"
                        },
                        [
                          _c("span", { staticClass: "child-lenght" }, [
                            _vm._v(
                              "[ " + _vm._s(data.childOrganizes.length) + " ]"
                            )
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "iconfont iconright",
                            class: data.hidden ? "iconleft" : "iconright"
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            }
          }
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-89795e78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-89795e78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/organize/choice-org.vue
// module id = null
// module chunks = 